import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryProvider } from '@/providers/QueryProvider';
import { router } from '@/router';
import { ToastContainer } from '@/components/common';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { DebugToolbar } from '@/components/debug/DebugToolbar';
import { DebugPanel } from '@/components/debug/DebugPanel';
import { Toaster } from 'react-hot-toast';
import './App.css';

function App() {
  React.useEffect(() => {
    console.log('App: React application started successfully');
  }, []);

  return (
    <ErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
        <ToastContainer />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
        {import.meta.env.VITE_SHOW_DEBUG === 'true' && <DebugToolbar />}
        <DebugPanel />
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App
